import React from 'react';
import { Plus } from 'lucide-react';

const FAQItem = ({ faq }) => {
    return (
        <details className="group border-b border-white/10 pb-8 pt-4 cursor-pointer">
            <summary className="flex justify-between items-center list-none">
                <span className="font-migra text-2xl md:text-3xl group-hover:pl-4 transition-all duration-300">{faq.q}</span>
                <Plus className="group-open:rotate-45 transition-transform duration-300 opacity-50" />
            </summary>
            <div className="mt-6 pl-4 md:pl-0 md:ml-auto md:w-1/2 opacity-60 text-sm leading-relaxed">
                {faq.a}
            </div>
        </details>
    );
};

export default FAQItem;
